import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import theme from './theme';
import './i18n/i18n';
import reportWebVitals, { defaultReporter } from './reportWebVitals';

// Fonts are loaded via Google Fonts in public/index.html (Inter, Playfair
// Display, JetBrains Mono) — no fontsource imports needed. Dropping
// @fontsource/poppins and @fontsource/playfair-display saved ~9 weight files
// from the bundle since the theme uses Inter + Playfair Display only.

const rootElement = document.getElementById('root');

const tree = (
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <Router>
        <App />
      </Router>
    </ChakraProvider>
  </React.StrictMode>
);

// The production build is statically prerendered for crawlers, but this app
// has several mount-driven animations, portals, and DOM effects. Hydrating the
// five-second prerendered snapshot is therefore brittle: React sees post-mount
// markup while the browser's first render starts from pre-mount state, which
// triggers #418/#423 and causes a visible replacement flash. Clear the
// prerendered root before the client render so users get one clean app mount
// while crawlers still receive the prerendered HTML source.
if (rootElement.hasChildNodes()) {
  rootElement.replaceChildren();
}

ReactDOM.createRoot(rootElement).render(tree);

// Measure Core Web Vitals (LCP/INP/CLS/FCP/TTFB) and ship to GA4 in prod
// or log to console in dev. Safe no-op if no analytics is wired up.
//
// Skip when running in a headless crawler (react-snap's puppeteer, Lighthouse
// CI, etc.) — those use older Chromium versions that may lack APIs the
// web-vitals package depends on (e.g. Array.prototype.at), and metrics
// from automated browsers aren't real user data anyway.
const isHeadlessCrawler =
  typeof navigator !== 'undefined' &&
  (navigator.webdriver || /HeadlessChrome|ReactSnap/i.test(navigator.userAgent || ''));

if (!isHeadlessCrawler) {
  reportWebVitals(defaultReporter);
}
